module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "GillSans",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "GillSans-Bold"
  }, [_vm._v("Other Close to Home Books by John McPherson")])]), _vm._v(" "), _c('p', {
    staticClass: "GillSans",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Close to Home"), _c('br'), _vm._v("\nOne Step Closer to Home"), _c('br'), _vm._v("\nDangerously Close to Home"), _c('br'), _vm._v("\nHome: The Final Frontier"), _c('br'), _vm._v("\nThe Honeymoon Is Over"), _c('br'), _vm._v("\nThe Silence of the Lamberts"), _c('br'), _vm._v("\nStriking Close to Home"), _c('br'), _vm._v("\nThe Close to Home Survival Guide"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "GillSans",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "GillSans-Bold"
  }, [_vm._v("Treasury Collections")]), _c('br'), _vm._v("\nClose to Home Revisited"), _c('br'), _vm._v(" Close to Home Unplugged")]), _vm._v(" "), _c('p', {
    staticClass: "GillSans",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "GillSans-Bold"
  }, [_vm._v("Also from John McPherson")]), _c('br'), _vm._v("\nHigh School Isn’t Pretty"), _c('br'), _vm._v("\nClose to Home: A Book of Postcards"), _c('br'), _vm._v("\nThe Barber of Bingo"), _c('br'), _vm._v("\nThe Get Well Book")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76cb533d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CTH_03.vue
// module id = 63
// module chunks = 0